import { Link } from "react-router-dom";

const logo = () => {
    return (
        <Link to='/'>
            <div className='flex items-center'>
                <img
                    src="assets/iimb-logo-white.png"
                    alt="logo"
                    className="w-auto md:h-14 h-10 md:mx-3"
                />
                <div className='w-1 h-14 border-r border-white mx-2'></div>
                <img
                    src="assets/mijsc-mizuho-india-japan-study-center-light.png"
                    alt="logo"
                    className="w-auto md:h-14 h-10 mx-3"
                />
            </div>
        </Link>
    )
}

export default logo